import React, { useState, useEffect, useRef, useContext } from "react";
import axios from "axios";
import "./QuestionnaireDash.css";
import Menu from "../../components/menu/Menu";
import QuestionnaireList from "../../components/questionnaireList/QuestionnaireList";
import { Context } from "../../context/Context";

const QuestionnaireDash = (props) => {

  const {questionnaireData, setQuestionnaireData, contentQuestionnaireLoaded, setContentQuestionnaireLoaded} = useContext(Context);

  // const [questionnaireData, setQuestionnaireData] = useState([]);
  // const [contentQuestionnaireLoaded, setContentQuestionnaireLoaded] = useState(false);
  const [search, setSearch] = useState("");
  const searchQuestionnaires = useRef("");
  const [isSorted, setSorted] = useState(true);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    localStorage.removeItem("disableUnLoad");
    localStorage.removeItem("ExerBuilderEdited");
  }, [])

  useEffect(() => {
    props.actSidebar(true);
    setIsLoading(true);
    var userData = JSON.parse(localStorage.getItem("userData"));
    if (userData === null) {
      props.checkLoggedIn(false);
    } else {
      axios.defaults.headers.common["Authorization"] = JSON.parse(localStorage.getItem("userData")).token;
      axios
        .post(window.ajaxLink + "cloud_questionnaires/questionnaires-list", {
          search,
        })
        .then((res) => {
          if (res.data.responseData) {
            setQuestionnaireData(res.data.responseData);
            setContentQuestionnaireLoaded(true);
            setIsLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
          setContentQuestionnaireLoaded(true);
          if (error.response.data.responseCode === 400 || error.response.data.responseCode === 401) {
            props.checkLoggedIn(false);
          }
        });
      // setContentQuestionnaireLoaded(true);
    }
  }, [props, search]);

  const updateSearchQuery = (value) => {
    if (value && value.length >= 3) {
      setSearch(value);
    } else if (value === "") {
      setSearch("");
    }
  };

  const handleSorting = (column, array) => {
    if (!isSorted) {
      var sorted = [...array].sort(function (a, b) {
        if (a[column] < b[column]) {
          return -1;
        }
        if (a[column] > b[column]) {
          return 1;
        }
        return 0;
      });
      setSorted(true);
    } else {
      sorted = [...array].sort(function (a, b) {
        if (a[column] > b[column]) {
          return -1;
        }
        if (a[column] < b[column]) {
          return 1;
        }
        return 0;
      });
      setSorted(false);
    }
    setQuestionnaireData(sorted);
  };

  return (
    <div>
      <Menu title={"Questionnaires"} />
      <div className="programs_dash_hold">
        {/* <div className="questionnaire_dash_top_hold"></div> */}
        
        <div className="table_component_container" style={{paddingTop: '10px'}}>
        <QuestionnaireList
          questionnaireData={questionnaireData}
          searchQuestionnaires={searchQuestionnaires}
          updateSearchQuery={updateSearchQuery}
          handleSorting={handleSorting}
          contentLoaded={contentQuestionnaireLoaded}
          isLoading={isLoading}
        />
        </div>
      </div>
    </div>
  );
};

export default QuestionnaireDash;
